// Exsurgo Tech — Shared theme JS (ported from static site; Storefront-API cart removed — Shopify handles cart natively)

// === NAV SCROLL EFFECT ===
(function () {
  const nav = document.querySelector('.nav');
  if (!nav) return;
  const update = () => nav.classList.toggle('scrolled', window.scrollY > 50);
  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// === MOBILE MENU ===
(function () {
  const hamburger = document.querySelector('.nav-hamburger');
  const mobile    = document.querySelector('.nav-mobile');
  if (!hamburger || !mobile) return;

  hamburger.addEventListener('click', () => {
    const open = hamburger.classList.toggle('open');
    mobile.classList.toggle('open', open);
    hamburger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  mobile.querySelectorAll('.nav-mobile-link').forEach(link => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('open');
      mobile.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!hamburger.contains(e.target) && !mobile.contains(e.target)) {
      hamburger.classList.remove('open');
      mobile.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
})();

// === SCROLL REVEAL ===
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  els.forEach(el => observer.observe(el));
})();

// === LIGHTWEIGHT ANALYTICS (data-track) ===
// Kept from the static site. window.va is Vercel-specific and absent on Shopify,
// so this is a harmless no-op until re-pointed at Shopify analytics.
(function () {
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-track]');
    if (!el) return;
    const name = el.dataset.track;
    if (window.va) window.va('event', { name });
  });
})();

// === AJAX ADD TO CART (live nav badge, stays on page — matches the static site) ===
(function () {
  const forms = document.querySelectorAll('form[action$="/cart/add"]');
  if (!forms.length) return;

  // Mirror the original static-site badge behaviour
  function updateBadge(count) {
    document.querySelectorAll('.nav-cart-count').forEach(el => {
      if (count > 0) {
        el.textContent = count > 9 ? '9+' : String(count);
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
        el.textContent = '';
      }
    });
  }

  forms.forEach(form => {
    form.addEventListener('submit', e => {
      // Only the "Add to Cart" submit fires this; the dynamic-checkout
      // (Buy Now / Shop Pay) button handles its own click and is untouched.
      e.preventDefault();

      const btn = form.querySelector('button[name="add"]');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(() => fetch('/cart.js', { headers: { 'Accept': 'application/json' } }))
        .then(r => r.json())
        .then(cart => {
          updateBadge(cart.item_count);
          if (btn) {
            btn.textContent = 'Added to Cart ✓';
            btn.style.background = '#16a34a';
            setTimeout(() => {
              btn.disabled = false;
              btn.textContent = label || 'Add to Cart';
              btn.style.background = '';
            }, 2000);
          }
        })
        .catch(() => {
          // Never block a purchase — fall back to the normal form submit
          if (btn) { btn.disabled = false; btn.textContent = label || 'Add to Cart'; }
          form.submit();
        });
    });
  });
})();
